import { InjectionToken } from "@angular/core";
import { WebRtcCommunicationEnvironmentConfig } from "./environment-config";


export const ENVIRONMENT_CONFIG = new InjectionToken<Partial<WebRtcCommunicationEnvironmentConfig>>('ENVIRONMENT_CONFIG');